<template>
  <div class="loading_overlay" v-if="isLoading.single" />
  <div class="md:container mx-auto pt-16 pb-40 px-4">
    <header>
      <h1
        class="text-3xl md:text-4xl mb-2 font-semibold md:leading-normal text-white capitalize"
      >
        Popular Celebrity
      </h1>
    </header>

    <div class="mt-3 grid grid-gap-2 grid-cols-2 xl:grid-cols-5 xs:grid-cols-4">
      <template v-if="isLoading && popularCelebs.length < 1">
        <skeleton-card-celebs
          v-for="(load, index) in loadArray"
          :key="index"
          :width="'md:w-11/12 sm:w-48 w-full'"
        />
      </template>
      <div
        v-else
        class="mt-8"
        v-for="popular in popularCelebs.results"
        :key="popular.id"
      >
        <card-celebs :data="popular" :width="'md:w-11/12 sm:w-48 w-full'" />
      </div>
    </div>

    <!-- Pagination -->
    <div class="mt-20 w-full flex justify-center">
      <v-pagination
        v-if="popularCelebs.total_pages > 1"
        v-model="popularCelebs.page"
        :pages="popularCelebs.total_pages"
        :range-size="1"
        :hideFirstButton="true"
        :hideLastButton="true"
        active-color="#DCEDFF"
        @update:modelValue="updateHandler"
        class="custom-pagination"
      />
    </div>
  </div>
</template>

<script>
import { onMounted, computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import CardCelebs from "@/components/Card/CardCelebs.vue";
import SkeletonCardCelebs from "@/components/Skeleton/SkeletonCardCelebs.vue";
export default {
  components: { CardCelebs, SkeletonCardCelebs },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const loadArray = ref(Array(20).fill());

    let popularCelebs = computed(() => store.state["tmdbApi"].popularCelebs);
    let isLoading = computed(() => store.state["tmdbApi"].isLoading);

    onMounted(() => {
      store.dispatch("tmdbApi/fetchPopularCelebrity", route.query);
    });

    watch(
      () => route.query,
      async query => {
        await store.dispatch("tmdbApi/fetchPopularCelebrity", query);
      }
    );

    const updateHandler = val => {
      router.push({
        path: route.path,
        query: {
          ...route.query,
          page: val
        }
      });
    };

    return {
      isLoading,
      popularCelebs,
      loadArray,
      updateHandler
    };
  }
};
</script>

<style></style>
